module.exports = __webpack_public_path__ + "78b8718cd736581305999805afb38529.jpg";